import Vue from 'vue'
import vuexI18n from 'vuex-i18n'
import objectAssign from 'object-assign'
import LocalePlugin from 'vux/src/plugins/locale/index.js'

import { getDefaultLang } from '../utils/lang'

import store from '../store'

import zhCN from '../locales/zh-CN'
import zhTW from '../locales/zh-TW'
import en from '../locales/en'
import id from '../locales/id'
import ms from '../locales/ms'
import es from '../locales/es'
import tr from '../locales/tr'
import ja from '../locales/ja'
import kr from '../locales/kr'
import ar from '../locales/ar'
import pt from '../locales/pt'

Vue.use(vuexI18n.plugin, store)

Vue.use(LocalePlugin)

/***
* 系统的语言列表
* @type {{en: {icon: string, locale: (*)}, 'zh-CN': {icon: string, locale: (*)}}}
*/
export const i18nLocales = {
'zh-CN': {
localeName: '简体中文',
key: 1,
locale: objectAssign(zhCN),
icon: require('../statics/images/flag/lang-zh-CN.png')
},
en: {
localeName: 'English',
key: 2,
locale: objectAssign(en),
icon: require('../statics/images/flag/lang-en.png')
},
'zh-TW': {
localeName: '繁體中文',
key: 3,
locale: objectAssign(zhTW),
icon: require('../statics/images/flag/lang-zh-tw.png')
},
id: {
localeName: 'Bahasa Indonesia',
key: 4,
locale: objectAssign(id),
icon: require('../statics/images/flag/lang-id.jpg')
},
ms: {
localeName: 'Melayu',
key: 5,
locale: objectAssign(ms),
icon: require('../statics/images/flag/lang-ms.png')
},
es: {

localeName: 'Español',
key: 6,
locale: objectAssign(es),
icon: require('../statics/images/flag/lang-es.png')
},
tr: {

localeName: 'Türkiye',
key: 7,
locale: objectAssign(tr),
icon: require('../statics/images/flag/lang-tr.png')
},
ja: {

localeName: '日本語',
key: 8,
locale: objectAssign(ja),
icon: require('../statics/images/flag/lang-ja.png')
},
kr: {

localeName: '한국인',
key: 9,
locale: objectAssign(kr),
icon: require('../statics/images/flag/lang-kr.png')
},
ar: {

localeName: 'العربية',
key: 10,
locale: objectAssign(ar),
icon: require('../statics/images/flag/lang-ar.png')
},
pt: {

localeName: 'Português',
key: 11,
locale: objectAssign(pt),
icon: require('../statics/images/flag/lang-pt.png')
}
}

const currentLocale =
store.getters.currentLocale ||
getDefaultLang() ||
process.env.DEFAULT_LANGUAGE

for (let i in i18nLocales) {
Vue.i18n.add(i, i18nLocales[i].locale)
}

Vue.i18n.set(currentLocale)

/*
const nowLocale = Vue.locale.get()
if (/zh/.test(nowLocale)) {
Vue.i18n.set('zh-CN')
} else {
Vue.i18n.set('en')
}
*/

export default Vue.i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js